import * as React from 'react';
import { css } from 'linaria';

const aStyle = css`
  color: unset;
`;

export const LinkWrapper: React.FC<{ href: string } & React.HTMLAttributes<HTMLElement>> = ({
  href,
  children,
  ...htmlProps
}) => (
  <a className={aStyle} href={href} {...htmlProps}>
    {children}
  </a>
);
